import { render, staticRenderFns } from "./CreateSource.vue?vue&type=template&id=4be20bee&scoped=true"
import script from "./CreateSource.vue?vue&type=script&lang=js"
export * from "./CreateSource.vue?vue&type=script&lang=js"
import style0 from "./CreateSource.vue?vue&type=style&index=0&id=4be20bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be20bee",
  null
  
)

export default component.exports